import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({ width = 20, height = 20, color = '#23262A' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.9987 1.66797H12.4987C11.3936 1.66797 10.3338 2.10696 9.55242 2.88836C8.77102 3.66976 8.33203 4.72957 8.33203 5.83464V8.33464H5.83203V11.668H8.33203V18.3346H11.6654V11.668H14.1654L14.9987 8.33464H11.6654V5.83464C11.6654 5.61362 11.7532 5.40166 11.9094 5.24538C12.0657 5.0891 12.2777 5.0013 12.4987 5.0013H14.9987V1.66797Z"
                fill={color}
            />
        </svg>
    );
};

export default IconProfilePencil;
